"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaChargeJuno = exports.yupChargeJuno = exports.schemaPaymentJuno = exports.yupPaymentJuno = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupPaymentJuno = yup.object({
    eventId: yup.string().default('').label('Id evento retorno'),
    eventType: yup.mixed().default(enums_1.ETypeWh.PAYMENT_NOTIFICATION).label('Tipo do evento retorno'),
    data: yup
        .array(yup.object({
        entityId: yup.string().default('').label('Id entity'),
        entityType: yup.string().default('').label('Type entity'),
        attributes: yup
            .object({
            createdOn: yup.string().default('').label('Data criação'),
            date: yup.string().default('').label('Data de pagamento'),
            releaseDate: yup.string().default('').label('Data de lançamento'),
            amount: yup.string().default('').label('Valor total do pagamento'),
            fee: yup.string().default('').label('Quantidade de cobrança'),
            status: yup.string().default('').label('Status da cobrança'),
            type: yup.mixed().default(enums_1.EPaymentAttTypes.BOLETO).label('Tipo pagamento'),
            charge: yup
                .object({
                id: yup.string().default('').label('Id da cobrança'),
                code: yup.number().default(0).label('Código da cobrança'),
                reference: yup.string().default('').label('Referência da cobrança'),
                amount: yup.string().default('').label('Valor da cobrança'),
                status: yup.string().default('').label('Status da cobrança'),
                dueDate: yup.string().default('').label('Data de vencimento da cobrança'),
                payer: yup
                    .object({
                    name: yup.string().default('').label('Nome do pagador'),
                    document: yup.string().default('').label('Documento pagador/cpf'),
                    address: yup.object({
                        street: yup.string().default('').label('Rua'),
                        number: yup.string().default('').label('Número. Se não houver, envie N/A'),
                        complement: yup.string().default('').label('Complemento'),
                        city: yup.string().default('').label('Cidade'),
                        state: yup.string().default('').label('Estado em sigla de Unidade Federativa (UF)'),
                        postCode: yup.string().default('').label('Código de Endereçamento Postal no Brasil (CEP)'),
                        neighborhood: yup.string().default('').label('Bairro'),
                    }),
                })
                    .label('Dados pagador'),
            })
                .label('Dados da cobrança'),
            digitalAccountId: yup.string().default('').label('Id da conta digital'),
        })
            .label('Attributes'),
    }))
        .default([])
        .label('Dados retorno evento'),
});
exports.schemaPaymentJuno = exports.yupPaymentJuno.shape({});
const yupBilling = yup.object({
    name: yup.string().required().default('').label('Nome do comprador'),
    document: yup.string().required().default('').label('CPF ou CNPJ do comprador. Envie sem ponto ou traço'),
    email: yup.string().email().required().max(80, 'Máximo de 80 caracteres').default('').label('E-mail do comprador'),
    address: yup
        .object({
        street: yup.string().required().default('').label('Rua'),
        number: yup.string().required().default('').label('Número. Se não houver, envie N/A'),
        complement: yup.string().notRequired().default(undefined).label('Complemento'),
        neighborhood: yup.string().notRequired().default(undefined).label('Bairro'),
        city: yup.string().required().default('').label('Cidade'),
        state: yup.string().required().default('').label('Estado em sigla de Unidade Federativa (UF)'),
        postCode: yup.string().required().default('').label('Código de Endereçamento Postal no Brasil (CEP)'),
    })
        .required()
        .label('Endereço'),
    secondaryEmail: yup.string().email().notRequired().max(80, 'Máximo de 80 caracteres').label('E-mail do comprador'),
    phone: yup
        .string()
        .notRequired()
        .max(25, 'Máximo de 25 caracteres')
        .default(undefined)
        .label('Telefone do comprador'),
    birthDate: yup.string().notRequired().default(undefined).label('Data de nascimento do comprador'),
    notify: yup
        .boolean()
        .notRequired()
        .default(false)
        .label('Define se o compador receberá e-mails de notificação diretamente da Juno'),
});
const yupCharge = yup.object({
    pixKey: yup.string().notRequired().default(undefined).label('Chave Pix aleatória'),
    pixIncludeImage: yup
        .string()
        .notRequired()
        .default(undefined)
        .label('Se habilitado, no response é retornado o campo imageInBase64.'),
    description: yup
        .string()
        .required()
        .max(400, 'Máximo de 400 caracteres')
        .default('')
        .label('Nesse campo deverá ser inserido informações referentes a produtos, serviços e afins relacionados a essa cobrança.'),
    references: yup
        .array(yup.string())
        .required()
        .default([])
        .label('Lista de references atrelada a cada cobrança gerada. O número de itens deve ser igual ao número de parcelas.'),
    totalAmount: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Valor total da transação. Requer uso do parâmetro installments. Se utilizado, não deverá ser utilizado amount.'),
    amount: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Valor total da parcela. O valor será aplicado para cada parcela. Se utilizado, não deverá ser utilizado totalAmount.'),
    dueDate: yup.string().required().default('').label('Data de vencimento'),
    installments: yup.number().notRequired().positive().default(undefined).label('Número de parcelas'),
    maxOverdueDays: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Número de dias permitido para pagamento após o vencimento.'),
    fine: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Multa para pagamento após o vencimento. Só é efetivo se maxOverdueDays for maior que zero.'),
    interest: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Juros ao mês. Só é efetivo se maxOverdueDays for maior que zero.'),
    discountAmount: yup
        .number()
        .notRequired()
        .default(undefined)
        .label('Valor absoluto de desconto para pagamento até o vencimento.'),
    discountDays: yup
        .number()
        .notRequired()
        .positive()
        .default(undefined)
        .label('Número de dias para pagamento antes do vencimento para dar o desconto.'),
    paymentTypes: yup
        .array(yup.mixed())
        .required()
        .default([enums_1.EPaymentTypes.BOLETO])
        .label('Tipos de pagamento permitidos'),
    paymentAdvance: yup
        .boolean()
        .required()
        .default(false)
        .label('Define se a cobrança, quando paga, terá sua liberação de seu valor de recebimento adiantada.'),
    feeSchemaToken: yup
        .string()
        .notRequired()
        .default(undefined)
        .label('Define o esquema de taxas alternativo para uma cobrança específica.'),
});
exports.yupChargeJuno = yup.object({
    charge: yupCharge.required().label('Charge'),
    billing: yupBilling.required().label('Billing'),
});
exports.schemaChargeJuno = exports.yupChargeJuno.shape({});
